
import { useAuthState } from "./use-auth-state";
import { useAuthHandlers } from "./use-auth-handlers";

export const useAuthForm = (initialSignUpMode = false) => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    country,
    setCountry,
    acceptedTerms,
    setAcceptedTerms,
    isLoading,
    setIsLoading,
    isSignUp,
    setIsSignUp,
    isForgotPassword,
    setIsForgotPassword,
  } = useAuthState(initialSignUpMode);

  const { handleAuth, handleResetPassword } = useAuthHandlers({
    email,
    password,
    firstName,
    lastName,
    country,
    acceptedTerms,
    setIsLoading,
    setIsForgotPassword,
    isSignUp,
  });

  return {
    email,
    setEmail,
    password,
    setPassword,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    country,
    setCountry,
    acceptedTerms,
    setAcceptedTerms,
    isLoading,
    isSignUp,
    setIsSignUp,
    isForgotPassword,
    setIsForgotPassword,
    handleAuth,
    handleResetPassword
  };
};
